function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';
import PropTypes from '../../_snowpack/pkg/prop-types.js';

function IconWarning({
  width,
  height,
  ...rest
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: width,
    height: height,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M8.0728.824c.6343-1.0987 2.2201-1.0987 2.8544 0l7.8496 13.5958c.6343 1.0987-.1586 2.472-1.4272 2.472H1.6504c-1.2686 0-2.0615-1.3733-1.4272-2.472L8.0728.824z",
    fill: "#FDF5BF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9204 14.9142L10.0709 1.3184c-.2538-.4395-.888-.4395-1.1418 0L1.0796 14.9142c-.2538.4395.0634.9888.5708.9888h15.6992c.5074 0 .8246-.5493.5708-.9888zM10.9272.824c-.6343-1.0987-2.22-1.0987-2.8544 0L.2232 14.4198c-.6343 1.0987.1586 2.472 1.4272 2.472h15.6992c1.2686 0 2.0615-1.3733 1.4272-2.472L10.9272.824z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5002 4.944c.4551 0 .824.3689.824.824v4.9439a.824.824 0 01-1.648 0v-4.944c0-.455.369-.824.824-.824z",
    fill: "#828A90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3238 13.1839a.824.824 0 01-.824.8239.824.824 0 110-1.6479.824.824 0 01.824.824z",
    fill: "#828A90"
  }));
}

IconWarning.defaultProps = {
  width: 19,
  height: 17
};
IconWarning.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
};
export default IconWarning;